import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class PropertyUse {
    constructor(doc)
    {
		this.label = null
		this.nonResidentialUseType = null
		this.nonResidentialUseTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.nonResidentialUseType = x.getStringElement(doc, "./ns:NonResidentialUseType");
		this.nonResidentialUseTypeOtherDescription = x.getStringElement(doc, "./ns:NonResidentialUseTypeOtherDescription");
   }

	GetNonResidentialUse() {
		return h.descriptionOrOther(this.nonResidentialUseType, this.nonResidentialUseTypeOtherDescription);
	}

}

